import { AMAZON } from '@/constants/amazon'

export default {
  methods: {
    async checkAuth() {
      // if (this.$liff.isLoggedIn()) {
      //   const { data } = await login({
      //     accessToken: await this.$liff.getAccessToken(),
      //   })
      //   if (data.access_token) {
      //     this.$cookies.set(this.Constants.COOKIE_ACCESS_TOKEN, data.access_token)
      //   }
      //   this.$store.commit('auth/SET_USER', data.customer)
      // }
    },

    async handleLogout(route = this.$routePage.EC_LINE031) {
      await this.$store.dispatch('auth/removeAuth')

      this.$store.commit('cart/EMPTY_CART')
      this.$store.commit('register/REMOVE_CUSTOMER')
      this.$session[AMAZON.CART_LINE004] = null
      this.$session[AMAZON.CART_LINE029] = null
      this.$session[AMAZON.SHIPPING_FEE] = null
      this.$session[AMAZON.CART_LINE015] = null
      this.$session[AMAZON.CART_LINE028] = null
      // Go to TOP page
      this.$router.push(route).catch(() => {})
    },
  },
}
